import React from "react";

import { t } from "i18next";

import AdsObjectiveTooltip from "./AdsObjectiveTooltip";

import type { GetScheduleKpisResponse } from "../../../api/FastAPI.types";
import type { PercentageItem } from "../../utils/ProgressBar";

const computeAdsObjectiveCompletion = (
  channelKpis?: GetScheduleKpisResponse,
): PercentageItem[] => {
  const getInterprogramAds = (): PercentageItem => {
    if (
      channelKpis?.data.ads_interprogram_duration &&
      channelKpis?.data.ads_duration &&
      channelKpis?.data.ads_completion
    ) {
      return {
        value:
          (channelKpis.data.ads_interprogram_duration /
            channelKpis.data.ads_duration) *
          channelKpis.data.ads_completion,
        tooltip: (
          <AdsObjectiveTooltip
            duration={channelKpis.data.ads_interprogram_duration}
            number={channelKpis.data.ads_interprogram_number}
            title={t("interprogramAds", { ns: "editor-fast-channel" })}
          />
        ),
      };
    }

    return { value: 0 };
  };

  const getInterstitialAds = (): PercentageItem => {
    if (
      channelKpis?.data.ads_interstitial_duration &&
      channelKpis?.data.ads_duration &&
      channelKpis?.data.ads_completion
    ) {
      return {
        value:
          (channelKpis.data.ads_interstitial_duration /
            channelKpis.data.ads_duration) *
          channelKpis.data.ads_completion,
        tooltip: (
          <AdsObjectiveTooltip
            duration={channelKpis.data.ads_interstitial_duration}
            number={channelKpis.data.ads_interstitial_number}
            title={t("interstitialAds", { ns: "editor-fast-channel" })}
          />
        ),
      };
    }

    return { value: 0 };
  };

  return [getInterprogramAds(), getInterstitialAds()];
};

export default computeAdsObjectiveCompletion;
